export default __webpack_public_path__ + "static/media/do.0624d1ac.svg";